import React from "react";
import Card from "./Card";
import Chip from "./Chip";

export default function FeatureGrid({ groups }) {
  return (
    <div className="mt-12 grid gap-6 lg:grid-cols-3">
      {(groups || []).map((g) => (
        <Card key={g.title} className="p-6" hoverable={false}>
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-sm font-semibold text-fk-ink dark:text-gray-100">{g.title}</div>
              {g.subtitle ? (
                <div className="mt-1 text-sm leading-relaxed text-fk-muted dark:text-gray-300">
                  {g.subtitle}
                </div>
              ) : null}
            </div>
            {g.tag ? <Chip className="shrink-0">{g.tag}</Chip> : null}
          </div>
          <ul className="mt-5 space-y-3">
            {(g.items || []).map((it) => (
              <li key={it.label} className="flex items-start gap-3">
                <span className="mt-2 inline-block h-2 w-2 shrink-0 rounded-full bg-fk-accent" />
                <div>
                  <div className="text-sm font-semibold text-fk-ink dark:text-gray-100">
                    {it.label}
                    {it.tag ? (
                      <span className="ml-2 align-middle text-xs font-medium text-fk-muted dark:text-gray-300">
                        ({it.tag})
                      </span>
                    ) : null}
                  </div>
                  {it.desc ? (
                    <div className="mt-1 text-sm leading-relaxed text-fk-muted dark:text-gray-300">
                      {it.desc}
                    </div>
                  ) : null}
                </div>
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  );
}

